import { copyToClipboard } from '@databases/copy-paste/copy-helper';

import { setIsCopied } from '../state/copy-state';

/**
 * Handles the action of copying a value link to the clipboard.
 */
export function copyValueLink({
  baseUrl,
  contentId,
  databasePath,
  entryId,
  fieldId,
}: {
  baseUrl: string;
  contentId: string;
  databasePath: string;
  entryId: string;
  fieldId: string;
}): void {
  const url = new URL(baseUrl + databasePath);

  url.searchParams.set('contentId', contentId);
  url.searchParams.set('entryId', entryId);
  url.searchParams.set('fieldId', fieldId);

  copyToClipboard(url.toString(), 'text/plain');

  setIsCopied(true);
  setTimeout(() => setIsCopied(false), 3000);
}
